import get from 'lodash/get';
import has from 'lodash/has';
import isPlainObject from 'lodash/isPlainObject';
import keys from 'lodash/keys';
import pullAllWith from 'lodash/pullAllWith';
import { createSelector } from 'reselect';
import { getExcludePages } from 'srcAlias/utils/config';
import {
  getCurrentPageIndex,
  getCurrentSegmentIndex,
} from './navigationSelectors';

export const getSegmentsConfig = state => state.segmentsConfig;

export const getCurrentSegmentName = createSelector(
  getSegmentsConfig,
  getCurrentSegmentIndex,
  (segmentsConfig, currentSegmentIndex) =>
    keys(segmentsConfig)[currentSegmentIndex]
);

export const getPreviousSegmentNames = createSelector(
  getSegmentsConfig,
  getCurrentSegmentName,
  (segmentsConfig, currentSegmentName) => {
    const segmentNames = Object.keys(segmentsConfig);
    return segmentNames.slice(0, segmentNames.indexOf(currentSegmentName));
  }
);

export const getCurrentSegmentConfig = createSelector(
  getSegmentsConfig,
  getCurrentSegmentName,
  (segmentsConfig, currentSegmentName) => segmentsConfig[currentSegmentName]
);

export const getCurrentPageName = createSelector(
  getCurrentSegmentConfig,
  getCurrentPageIndex,
  (currentSegmentConfig, currentPageIndex) => {
    const formSchemaPages = keys(
      get(currentSegmentConfig, 'formSchema.properties', {})
    );

    const staticPages = get(currentSegmentConfig, `pages`, []);
    let pages = [...formSchemaPages, ...staticPages];

    if (has(currentSegmentConfig, 'pagesConfig')) {
      const excludePages = getExcludePages(currentSegmentConfig.pagesConfig);
      pages = pullAllWith(pages, excludePages);
    }

    const pageConfig = get(pages, currentPageIndex, null);
    return isPlainObject(pageConfig) ? pageConfig.page : pageConfig;
  }
);

export const getCurrentPageGroup = createSelector(
  getCurrentSegmentConfig,
  getCurrentPageName,
  (currentSegmentConfig, currentPageName) => {
    if (has(currentSegmentConfig, 'formSchema.properties')) {
      const formSchemaPageNames = Object.keys(
        currentSegmentConfig.formSchema.properties
      );

      if (formSchemaPageNames.includes(currentPageName)) {
        return currentSegmentConfig.formSchemaName || 'QuestionSet';
      }
    }

    return null;
  }
);
